import { RepairTypeEnum } from '@vatos-pas/common';

export const canEditHOServiceRepair = (
  repairType: string | undefined,
  canManageHOService: boolean,
): boolean => {
  if (repairType === RepairTypeEnum.HOService) return canManageHOService;
  return true;
};
